function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["checkboxProps", "className", "defaultChecked", "disabled", "helpText", "helpTextProps", "id", "indeterminate", "inputProps", "label", "labelPosition", "labelProps", "look", "name", "onBlur", "onChange", "required", "requiredLabel", "showLabel", "textProps", "value", "wrapperRef"],
  _excluded2 = ["labelPosition", "look", "showLabel"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useRef, useEffect, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import { InputLabelPositions, InputLooks } from "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import { bounce } from "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import { fontFamilyBook } from "../../../../themes/fonts.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import { screenReaderOnly } from "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import { mergeRefs } from "../../../../utilities/refs.js";
import "../../../atoms/icon/font-icon/font-icon.js";
import 'react-transition-group';
import "../../../atoms/alert/inline-alert/inline-alert.js";
import "../../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import 'react-laag';
import '@brandfolder/utilities';
import "../../../atoms/button/close-button/close-button.js";
import "../../../atoms/button/color-button/color-button.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../../atoms/button/icon-button/icon-button.js";
import "../../../atoms/button/standard-button/standard-button.js";
import "../../../atoms/loader/circle-loader/circle-loader.js";
import "../../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../../atoms/divider/standard-divider/standard-divider.js";
import "../../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../../atoms/heading/standard-heading/standard-heading.js";
import { StandardLabel } from "../../../atoms/label/standard-label/standard-label.js";
import "../../../atoms/link/button-link/button-link.js";
import "../../../atoms/link/standard-link/standard-link.js";
import "../../../atoms/popout/standard-popout/standard-popout.js";
import "../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../../atoms/table/standard-table/caption.js";
import "../../../atoms/table/standard-table/tbody.js";
import "../../../atoms/table/standard-table/tr-empty.js";
import "../../../atoms/table/standard-table/td.js";
import "../../../atoms/table/standard-table/tr.js";
import "../../../atoms/table/standard-table/table.js";
import "../../../atoms/table/standard-table/tfoot.js";
import "../../../atoms/table/standard-table/th.js";
import "../../../atoms/table/standard-table/thead.js";
import "../../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../../atoms/table/dnd-table/dnd-table-drag-context.js";
import { HelpText } from "../../../atoms/text/help-text/help-text.js";
import "../../../atoms/text/standard-text/standard-text.js";
import "../../../internal/list/standard-list/standard-list.js";
import "../../../internal/listbox/standard-listbox/standard-listbox.js";
import "../../../internal/listitem/standard-listitem/standard-listitem.js";
import "../../../internal/option/standard-option/standard-option.js";
import "../../../internal/textarea/fake-textarea.js";
import "../../../internal/textfield/textfield-addon.js";
import "../../../internal/textfield/textfield-body.js";
import "../../../internal/textfield/textfield-header.js";
import "../../../internal/textfield/textfield-icon.js";
import "../../../internal/textfield/textfield-inner.js";
import { TextfieldWrapper } from "../../../internal/textfield/textfield-wrapper.js";
import { BaseCheckbox } from "../base-checkbox/base-checkbox.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardCheckbox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;
  var checkboxProps = props.checkboxProps,
    className = props.className,
    defaultChecked = props.defaultChecked,
    disabled = props.disabled,
    helpText = props.helpText,
    helpTextProps = props.helpTextProps,
    id = props.id,
    indeterminate = props.indeterminate,
    inputProps = props.inputProps,
    label = props.label,
    labelPosition = props.labelPosition,
    labelProps = props.labelProps,
    look = props.look,
    name = props.name,
    onBlur = props.onBlur,
    onChange = props.onChange,
    required = props.required,
    requiredLabel = props.requiredLabel,
    showLabel = props.showLabel,
    textProps = props.textProps,
    value = props.value,
    wrapperRef = props.wrapperRef,
    otherProps = _objectWithoutProperties(props, _excluded);
  var hasHelpText = !!helpText;
  var hasRequired = required && !!requiredLabel;
  var helpTextId = "".concat(id, "-help-text");
  var labelId = "".concat(id, "-label");
  var inputRef = useRef(null);
  useEffect(function () {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate || false;
    }
  }, [indeterminate, inputRef]);
  return /*#__PURE__*/React.createElement(TextfieldWrapper, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-checkbox__standard': true,
      'bf-checkbox__standard--disabled': disabled,
      'bf-checkbox__standard--help-text': hasHelpText,
      'bf-checkbox__standard--indeterminate': indeterminate
    }, _defineProperty(_classnames, "bf-checkbox__standard--label-".concat(labelPosition), showLabel), _defineProperty(_classnames, 'bf-checkbox__standard--label-hidden', !showLabel), _defineProperty(_classnames, "bf-checkbox__standard--look-".concat(look), look), _defineProperty(_classnames, 'bf-checkbox__standard--required', hasRequired), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    labelPosition: labelPosition,
    ref: wrapperRef
  }), /*#__PURE__*/React.createElement(BaseCheckbox, _extends({}, inputProps, {
    "aria-describedby": hasHelpText ? helpTextId : undefined,
    "aria-disabled": disabled,
    className: classnames(_defineProperty({
      'bf-checkbox__input': true
    }, "".concat(inputProps === null || inputProps === void 0 ? void 0 : inputProps.className), !!(inputProps !== null && inputProps !== void 0 && inputProps.className))),
    defaultChecked: defaultChecked,
    disabled: disabled,
    id: id,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    ref: mergeRefs([ref, inputRef]),
    required: hasRequired,
    value: value
  })), /*#__PURE__*/React.createElement(StandardLabel, _extends({}, labelProps, {
    className: classnames(_defineProperty({
      'bf-checkbox__label': true
    }, "".concat(labelProps === null || labelProps === void 0 ? void 0 : labelProps.className), !!(labelProps !== null && labelProps !== void 0 && labelProps.className))),
    htmlFor: id,
    id: labelId,
    required: hasRequired,
    requiredLabel: requiredLabel
  }), /*#__PURE__*/React.createElement("span", _extends({}, checkboxProps, {
    "aria-hidden": true,
    className: classnames(_defineProperty({
      'bf-checkbox__checkbox': true
    }, "".concat(checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.className), !!(checkboxProps !== null && checkboxProps !== void 0 && checkboxProps.className)))
  }), /*#__PURE__*/React.createElement("svg", {
    className: "bf-checkbox__checkmark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "20,6 9,17 4,12",
    strokeMiterlimit: "10",
    strokeWidth: "2"
  })), /*#__PURE__*/React.createElement("svg", {
    className: "bf-checkbox__indeterminate",
    height: "1",
    width: "8",
    viewBox: "0 0 8 1"
  }, /*#__PURE__*/React.createElement("rect", {
    height: "1",
    width: "8"
  }))), /*#__PURE__*/React.createElement("span", _extends({}, textProps, {
    className: classnames(_defineProperty({
      'bf-checkbox__text': true
    }, "".concat(textProps === null || textProps === void 0 ? void 0 : textProps.className), !!(textProps !== null && textProps !== void 0 && textProps.className)))
  }), label)), hasHelpText && /*#__PURE__*/React.createElement(HelpText, _extends({}, helpTextProps, {
    id: helpTextId
  }), helpText));
});
var Textfield = styled(BaseStandardCheckbox)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  .bf-checkbox__checkmark,\n  .bf-checkbox__indeterminate {\n    display: none;\n  }\n\n  .bf-checkbox__input {\n    ", "\n\n    + .bf-checkbox__label {\n      .bf-checkbox__checkbox {\n        background-color: ", ";\n        border: 1px solid ", ";\n        border-radius: 2px;\n        cursor: pointer;\n        flex-shrink: 0;\n        height: 14px;\n        margin-block-start: 3.5px;\n        outline-color: transparent;\n        transition:\n          background-color 0.2s ease,\n          border-color 0.2s ease,\n          outline-color 0.2s ease;\n        width: 14px;\n\n        &:hover {\n          border-color: ", ";\n        }\n      }\n    }\n\n    &:checked {\n      + .bf-checkbox__label {\n        .bf-checkbox__checkbox {\n          animation: ", " 0.2s ease;\n          background-color: ", ";\n          border-color: ", ";\n\n          .bf-checkbox__checkmark {\n            display: block;\n\n            polyline {\n              fill: none;\n              stroke: ", ";\n            }\n          }\n        }\n      }\n    }\n\n    &:focus-visible {\n      + .bf-checkbox__label {\n        .bf-checkbox__checkbox {\n          outline-color: ", ";\n          outline-offset: 2px;\n          outline-style: solid;\n          outline-width: 2px;\n        }\n      }\n    }\n\n    &:indeterminate {\n      + .bf-checkbox__label {\n        .bf-checkbox__checkbox {\n          animation: ", " 0.2s ease;\n          background-color: ", ";\n          border-color: ", ";\n\n          .bf-checkbox__indeterminate {\n            display: block;\n            margin: 5.5px 0 0 2px;\n\n            rect {\n              fill: ", ";\n            }\n          }\n        }\n      }\n    }\n\n    &:disabled {\n      + .bf-checkbox__label {\n        .bf-checkbox__checkbox {\n          animation: none;\n          background-color: ", ";\n          border-color: ", ";\n          cursor: not-allowed;\n\n          .bf-checkbox__checkmark {\n            polyline {\n              fill: none;\n              stroke: ", ";\n            }\n          }\n\n          .bf-checkbox__indeterminate {\n            rect {\n              fill: ", ";\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .bf-label__standard {\n    font-family: ", ";\n    font-weight: 400;\n  }\n\n  &.bf-checkbox__standard--label-hidden {\n    .bf-checkbox__input {\n      + .bf-checkbox__label {\n        .bf-checkbox__checkbox {\n          position: static;\n        }\n      }\n    }\n\n    .bf-checkbox__text {\n      ", "\n    }\n\n    .bf-label__standard {\n      margin-left: 0;\n    }\n\n    .bf-text__help {\n      ", "\n      margin-left: 0;\n    }\n  }\n\n  &.bf-textfield__wrapper--label-position-right {\n    .bf-checkbox__text {\n      margin-inline-start: 12px;\n    }\n\n    .bf-text__help {\n      margin-inline-start: 26px;\n    }\n  }\n\n  &.bf-textfield__wrapper--label-position-left {\n    align-items: flex-end;\n\n    .bf-checkbox__checkbox {\n      order: 1;\n    }\n\n    .bf-checkbox__text {\n      margin-inline-end: 12px;\n    }\n\n    .bf-text__help {\n      margin-inline-end: 26px;\n    }\n  }\n"])), screenReaderOnly, function (_ref) {
  var look = _ref.look,
    theme = _ref.theme;
  return theme.checkbox[look].backgroundColor;
}, function (_ref2) {
  var look = _ref2.look,
    theme = _ref2.theme;
  return theme.checkbox[look].borderColor;
}, function (_ref3) {
  var look = _ref3.look,
    theme = _ref3.theme;
  return theme.checkbox[look].borderColorHover;
}, bounce, function (_ref4) {
  var look = _ref4.look,
    theme = _ref4.theme;
  return theme.checkbox[look].backgroundColorChecked;
}, function (_ref5) {
  var look = _ref5.look,
    theme = _ref5.theme;
  return theme.checkbox[look].borderColorChecked;
}, function (_ref6) {
  var look = _ref6.look,
    theme = _ref6.theme;
  return theme.checkbox[look].fillColorChecked;
}, function (_ref7) {
  var look = _ref7.look,
    theme = _ref7.theme;
  return theme.checkbox[look].outlineColorFocus;
}, bounce, function (_ref8) {
  var look = _ref8.look,
    theme = _ref8.theme;
  return theme.checkbox[look].backgroundColorIndeterminate;
}, function (_ref9) {
  var look = _ref9.look,
    theme = _ref9.theme;
  return theme.checkbox[look].borderColorIndeterminate;
}, function (_ref10) {
  var look = _ref10.look,
    theme = _ref10.theme;
  return theme.checkbox[look].fillColorIndeterminate;
}, function (_ref11) {
  var look = _ref11.look,
    theme = _ref11.theme;
  return theme.checkbox[look].backgroundColorDisabled;
}, function (_ref12) {
  var look = _ref12.look,
    theme = _ref12.theme;
  return theme.checkbox[look].borderColorDisabled;
}, function (_ref13) {
  var look = _ref13.look,
    theme = _ref13.theme;
  return theme.checkbox[look].fillColorDisabled;
}, function (_ref14) {
  var look = _ref14.look,
    theme = _ref14.theme;
  return theme.checkbox[look].fillColorDisabled;
}, fontFamilyBook, screenReaderOnly, screenReaderOnly);
/**
 * A `<input type="checkbox">` element that represents a boolean (on/off) state.
 * `id` and `label` are required for accessibility.
 *
 * `InputLabelPositions.Right` is the default label position.
 * Only `InputLabelPositions.Left` is also currently supported.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox
 *
 * @param props StandardCheckboxProps
 * @returns FunctionComponent<StandardCheckboxProps>
 */
var StandardCheckbox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? InputLabelPositions.Right : _props$labelPosition,
    _props$look = props.look,
    look = _props$look === void 0 ? InputLooks.Default : _props$look,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Textfield, _extends({}, otherProps, {
    labelPosition: labelPosition,
    look: look,
    ref: ref,
    showLabel: showLabel
  })));
});
export { StandardCheckbox };